import theme from '../../services/theme'

export default {
    root: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        position: 'absolute',
        backgroundColor: theme.palette.loader.main,
        opacity: '0.6',
        zIndex: theme.zIndex.loader
    },
    media: {
        margin: '25% auto',
        color: theme.palette.loader.color,
        fontWeight: 'bold',
        textAlign: 'center'
    }
}